import { render, staticRenderFns } from "./InventoryRowStatus.vue?vue&type=template&id=61d3adf3"
import script from "./InventoryRowStatus.vue?vue&type=script&lang=js"
export * from "./InventoryRowStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports